import CouponCrudPage from './CouponCrudPage'
export {CouponCrudPage}
export default CouponCrudPage
